import React, { useState } from 'react';
import { legalDocs } from '../data/legal';
import type { LegalDoc } from '../data/legal';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDoc['id'] | null>(null);
  return <footer className="w-full bg-white pb-12 pt-12" data-id="element-56" data-mp="32lrlpcbxyvjg">
      <div className="mx-auto w-full max-w-3xl px-5 text-center sm:px-8" data-id="element-57" data-mp="36oo5h6d7wxoz">
        <p className="text-sm leading-relaxed text-ink/55" data-id="element-58" data-mp="3ufa5cad2jbnw">
          Este material es de carácter educativo y no sustituye el diagnóstico ni el tratamiento
          médico. Si presentas pérdida de control de esfínteres, debilidad progresiva o una fractura
          reciente, acude a un servicio de emergencia de inmediato.
        </p>

        <nav aria-label="Enlaces legales" className="mt-8 flex items-center justify-center gap-3" data-id="element-59" data-mp="3qc3zv4xs5oih">
          {(Object.values(legalDocs) as LegalDoc[]).map((doc, index) => <React.Fragment key={doc.id} data-id="element-60" data-mp="2eyjqxoc534vo" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" className="h-3 w-px bg-sand-200" data-id="element-61" data-mp="3l9k292unj58j" />}
              <button type="button" onClick={() => setOpenDoc(doc.id)} className="rounded text-sm font-semibold text-navy-700 underline decoration-sand-200 decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-ember-600 hover:decoration-ember-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember-500" data-id="element-62" data-mp="3gagyrmubl72o">
                {doc.label}
              </button>
            </React.Fragment>)}
        </nav>

        <p className="mt-6 text-xs uppercase tracking-[0.18em] text-ink/40" data-id="element-63" data-mp="hrihjt43600y">
          <a href="https://ciatica.testeaofertas.com" className="rounded transition-colors duration-150 ease-out hover:text-ink/70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember-500" data-id="element-64" data-mp="ctgy372qzyoy">
            ciatica.testeaofertas.com
          </a>
          <span aria-hidden="true" className="mx-2" data-id="element-65" data-mp="two4vw6mvl8d">
            ·
          </span>
          Protocolo de Rescate Lumbar · {new Date().getFullYear()}
        </p>
      </div>

      <LegalModal doc={openDoc ? legalDocs[openDoc] : null} onClose={() => setOpenDoc(null)} data-id="element-66" data-mp="13s9as5etp5ne" />
    </footer>;
}